export enum PROVIDER_UPDATE_TYPE {
  TERMINATE = 'terminate',
  EXTENSION = 'extension',
  INITIALIZED = 'initialized',
}
